import { Box, Typography } from "@mui/material";
import {
  gridFilteredSortedRowIdsSelector,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";

import { isNumber } from "utils/typeGuards";

import CustomGridToolbarAddButton from "./components/CustomGridToolbarAddButton";
import CustomGridToolbarColumnsButton from "./components/CustomGridToolbarColumnsButton";
import CustomGridToolbarRefetchButton from "./components/CustomGridToolbarRefetchButton";
import CustomGridToolbarResetButton from "./components/CustomGridToolbarResetButton";

interface CustomDataGridToolbarProps {
  title?: string;
  refetch?: () => void;
  onAdd?: () => void;
  showResetButton?: boolean;
  isServerSide: boolean;
  rowCountOverride?: number;
}

const CustomDataGridToolbar = ({
  title,
  refetch,
  onAdd,
  showResetButton,
  isServerSide = false,
  rowCountOverride,
}: CustomDataGridToolbarProps) => {
  const apiRef = useGridApiContext();

  const filteredRowIds = useGridSelector(
    apiRef,
    gridFilteredSortedRowIdsSelector,
  );

  const rowCount =
    isServerSide && isNumber(rowCountOverride)
      ? Math.max(rowCountOverride, 0)
      : filteredRowIds.length;

  const displayTitle = `${title ? `${title}: ` : ""} ${rowCount} Matches`;

  return (
    <GridToolbarContainer>
      <Typography variant="h6" sx={{ padding: ".75em" }}>
        {displayTitle}
      </Typography>

      <GridToolbarFilterButton />
      <Box
        flex={1}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          marginRight: "1em",
        }}
      >
        <GridToolbarQuickFilter />
        <CustomGridToolbarColumnsButton />
        <CustomGridToolbarRefetchButton refetch={refetch} />
        <CustomGridToolbarAddButton onAdd={onAdd} />
        {showResetButton && <CustomGridToolbarResetButton />}
      </Box>
    </GridToolbarContainer>
  );
};
export default CustomDataGridToolbar;
